import React from 'react';
import { StyleSheet } from 'react-native';

import { Text } from '@/components/TextComponent';
import { Image } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';

type Props = {
    teamImageSource: { uri?: string };
    shouldShowLogoText: boolean;
    logoText?: string;
};

export const PlayerTileLogo = ({ teamImageSource, shouldShowLogoText, logoText }: Props) => {
    if (shouldShowLogoText) {
        return (
            <Text variant="labelMedium" fontWeight={600} color={ds.colorToken.text.primary}>
                {logoText}
            </Text>
        );
    }

    return <Image source={teamImageSource} resizeMode="contain" style={styles.logoSize} />;
};

const styles = StyleSheet.create({
    logoSize: {
        width: 24,
        height: 24,
    },
});
